var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form-item",
    { attrs: { label: _vm.i18nt("designer.setting.multiple") } },
    [
      _c("el-switch", {
        on: { change: _vm.onMultipleSelected },
        model: {
          value: _vm.optionModel.multiple,
          callback: function ($$v) {
            _vm.$set(_vm.optionModel, "multiple", $$v)
          },
          expression: "optionModel.multiple",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }